export default __webpack_public_path__ + "static/media/cancel.7642c76b.png";